'use client';

import { useEffect } from 'react';
import { activateAnalyticsBootstrap } from '@/reporting/analyticsLoader';

/** body 尾部拥有外链启动权；重复 mount 复用同一个 document 启动门。 */
export default function AnalyticsBootstrapScripts() {
  useEffect(() => {
    activateAnalyticsBootstrap();
  }, []);
  return <span id="analytics-loader-anchor" hidden aria-hidden="true" />;
}
